export default "__VITE_ASSET__pI08Lnf4__"